import CheckBoxList, {
  type CheckBoxListOption,
  type CheckBoxListValue,
} from "../../../../../Forms/Controls/CheckBoxList/CheckBoxList";
import React from "react";
import "./FilterFieldSearchResult.scss";
import { TextButton, normalizeNumbers } from "@SeemplicityDev/shared";
import { MAX_RESULTS_TO_SHOW } from "../../../../../Findings/FindingsFilters/FilterUtils";
import { getAdditionalDataTitle } from "../../../../../Findings/FindingDetailsPane/FindingsDetailsPaneComponents/Details/DetailsUtils";
import type { MenuState, MenuAction } from "../FilterFieldsSearch";

export interface FilterFieldSearchResultProps {
  resourceType: string;
  resourceLabel?: string;
  totalCount: number;
  loadValues: boolean;
  valueOptions: CheckBoxListOption[];
  onCheckOption: (resourceType: string, value: CheckBoxListValue) => void;
  selectedValues: CheckBoxListValue;
  resourceFullView?: boolean;
  onShowMoreClick: (resourceType: string) => void;
  // `menu`/`setMenu` are threaded through by the parent but unused here.
  menu?: MenuState;
  setMenu?: (newState: MenuAction) => void;
}

const FilterFieldSearchResult: React.FC<FilterFieldSearchResultProps> = ({
  resourceType,
  resourceLabel: resourceLabelOverride,
  totalCount,
  loadValues,
  valueOptions,
  onCheckOption,
  selectedValues,
  resourceFullView,
  onShowMoreClick,
}) => {
  const getCheckboxList = () => {
    return (
      <CheckBoxList
        data-testid={`filter-dropdown-item-${resourceType}`}
        className={"filter-dropdown-item"}
        label={``}
        value={selectedValues}
        onChange={(val) => onCheckOption(resourceType, val)}
        options={valueOptions}
        direction={"column"}
        inDropdown
        loading={loadValues}
        withBg
      />
    );
  };

  const resourceLabel =
    resourceLabelOverride || getAdditionalDataTitle(resourceType);

  return (
    <div className={"search-result-section-container"}>
      <div className={`search-result-section-toggle-wrap`}>
        <div className={"filter-search-title-wrap"}>
          <div className={"search-type-header filter-search-title-text"}>
            {resourceLabel}
          </div>
          <div className={"search-total-count-wrap"}>
            <div className={"search-total-count filter-search-title-count"}>
              {normalizeNumbers(totalCount, 1)}
            </div>
          </div>
        </div>
      </div>
      {getCheckboxList()}
      {!resourceFullView && totalCount > MAX_RESULTS_TO_SHOW && (
        <TextButton
          wrapperClassName={"show-more-btn-wrap"}
          data-testid={"show-more"}
          type={"button"}
          label={"Show more..."}
          buttonStyle={"textLink"}
          onClick={() => onShowMoreClick(resourceType)}
        />
      )}
    </div>
  );
};

export default FilterFieldSearchResult;
